import { Grid } from '../atoms/Grid/Grid';
import { AquariumStoryCard } from './AquariumStoryCard';
import { JournalMilestones } from './JournalMilestones';

/**
 * The journal page's insight row (audit #7): milestones of the tank and the
 * on-demand AI aquarium story. Its own component so the journal list page
 * changes by one line only.
 */
export function JournalInsights({ aquariumId }: { aquariumId: string }) {
  if (!aquariumId) return null;
  return (
    <Grid minItemWidth="md" gap="4" data-testid="journal-insights">
      <JournalMilestones aquariumId={aquariumId} />
      <AquariumStoryCard aquariumId={aquariumId} />
    </Grid>
  );
}

export default JournalInsights;
